"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var CheckIcon_1 = __importDefault(require("../common/FirstSection/CheckIcon"));
var styles_1 = require("../common/styles");
var List_1 = __importDefault(require("../common/List"));
var clock1_webp_1 = __importDefault(require("./assets/clock1.webp"));
var clock2_webp_1 = __importDefault(require("./assets/clock2.webp"));
var clock3_webp_1 = __importDefault(require("./assets/clock3.webp"));
var clock4_jpg_1 = __importDefault(require("./assets/clock4.jpg"));
var clock5_jpg_1 = __importDefault(require("./assets/clock5.jpg"));
var clock6_jpg_1 = __importDefault(require("./assets/clock6.jpg"));
var bg_png_1 = __importDefault(require("./FirstSection/bg.png"));
exports.default = {
    bgimageStyle: "\n        max-width: 790px;\n        top: -30px;\n        right: -70px;\n    ",
    FirstSectionBgImage: bg_png_1.default,
    axiosLink: '/api/products/round_plastic_clock?format=json',
    productLink: '/round_plastic_clocks/new_v2',
    productNamePlural: 'часы',
    seoText: (react_1.default.createElement(styles_1.Text, null, "\u0412\u0440\u0435\u043C\u044F \u0432\u0441\u043F\u043E\u043C\u043D\u0438\u0442\u044C \u043E \u0432\u0430\u0448\u0435\u0439 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438! \u0410 \u043F\u043E\u043C\u043E\u0433\u0443\u0442 \u0432 \u044D\u0442\u043E\u043C \u0447\u0430\u0441\u044B \u0441 \u043B\u043E\u0433\u043E\u0442\u0438\u043F\u043E\u043C. \u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0435\u0433\u043E \u043C\u043E\u0436\u043D\u043E \u0432 \u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u043C \u0440\u0435\u0434\u0430\u043A\u0442\u043E\u0440\u0435 \u0438\u043B\u0438 \u0437\u0430\u043A\u0430\u0437\u0430\u0442\u044C \u0440\u0430\u0437\u0440\u0430\u0431\u043E\u0442\u043A\u0443 \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F \u0443 \u043D\u0430\u0448\u0438\u0445 \u0434\u0438\u0437\u0430\u0439\u043D\u0435\u0440\u043E\u0432. \u041C\u044B \u0434\u0435\u043B\u0430\u0435\u043C \u043F\u0435\u0447\u0430\u0442\u044C \u043D\u0430 \u0447\u0430\u0441\u0430\u0445 \u0441 \u043F\u043B\u0430\u0441\u0442\u0438\u043A\u043E\u0432\u043E\u0439 \u0438\u043B\u0438 \u0434\u0435\u0440\u0435\u0432\u044F\u043D\u043D\u043E\u0439 \u0440\u0430\u043C\u043A\u043E\u0439 \u043A\u0440\u0443\u0433\u043B\u043E\u0439 \u0438\u043B\u0438 \u043A\u0432\u0430\u0434\u0440\u0430\u0442\u043D\u043E\u0439 \u0444\u043E\u0440\u043C\u044B. \u0414\u043E\u0441\u0442\u0430\u0432\u0438\u043C \u0437\u0430\u043A\u0430\u0437 \u0432 \u043B\u044E\u0431\u043E\u0439 \u0433\u043E\u0440\u043E\u0434 \u0420\u0424.")),
    firstSectionTitle: (react_1.default.createElement(styles_1.MainTitle, null,
        "\u041F\u0435\u0447\u0430\u0442\u044C \u043D\u0430 \u0447\u0430\u0441\u0430\u0445",
        react_1.default.createElement("br", null),
        " \u043D\u0430 \u0437\u0430\u043A\u0430\u0437")),
    firstSectionText: (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(styles_1.Text, null,
            "\u0427\u0430\u0441\u044B \u0440\u0430\u0437\u043D\u043E\u0439 \u0444\u043E\u0440\u043C\u044B \u0441 \u043B\u043E\u0433\u043E\u0442\u0438\u043F\u0430\u043C\u0438, \u043D\u0430\u0434\u043F\u0438\u0441\u044F\u043C\u0438, ",
            react_1.default.createElement("br", null),
            "\u0440\u0438\u0441\u0443\u043D\u043A\u0430\u043C\u0438 \u043E\u0442 1 \u0448\u0442."),
        react_1.default.createElement(List_1.default, { icon: react_1.default.createElement(CheckIcon_1.default, null) },
            react_1.default.createElement(styles_1.Text, null, "\u041A\u043E\u0440\u043F\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u044B\u0435 \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u044B \u0438 \u0441\u0443\u0432\u0435\u043D\u0438\u0440\u044B \u043F\u043E\u0434 \u043A\u043B\u044E\u0447"),
            react_1.default.createElement(styles_1.Text, null, "\u041F\u043E\u043C\u043E\u0449\u044C \u0434\u0438\u0437\u0430\u0439\u043D\u0435\u0440\u0430"),
            react_1.default.createElement(styles_1.Text, null, "\u0418\u0437\u0433\u043E\u0442\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u0432 \u0434\u0435\u043D\u044C \u043E\u0431\u0440\u0430\u0449\u0435\u043D\u0438\u044F"),
            react_1.default.createElement(styles_1.Text, null, "\u0421\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0435 \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0441\u0442\u0432\u043E")))),
    productsTitle: 'Часы для нанесения',
    products: [
        {
            link: '/round_plastic_clocks/new_v2',
            image: clock1_webp_1.default,
            text: 'Часы круглые из пластика',
        },
        {
            link: '/square_wood_clocks/new_v2',
            image: clock2_webp_1.default,
            text: 'Часы квадратные из пластика (под дерево)',
        },
        {
            link: '/round_wood_clocks/new_v2',
            image: clock3_webp_1.default,
            text: 'Часы круглые из дерева',
        },
        {
            image: clock4_jpg_1.default,
            text: 'Часы настенные с выпуклым пластиковым стеклом',
        },
        {
            image: clock5_jpg_1.default,
            text: 'Часы настенные многогранник',
        },
        {
            image: clock6_jpg_1.default,
            text: 'Часы настенные Gronde с выпуклым стеклом',
        },
        {},
        {},
    ]
};
